export const apiConfig = {
  baseURL: import.meta.env.VITE_API_BASE_URL || 'https://api.pigeonhole.io/v1',
  timeout: 30000,
};
